// extracted by mini-css-extract-plugin
module.exports = {"iframe":"src/screens/Ekyc/Start/styles__iframe--MwfFL"};